<template>
  <div style="width:100%;height:100%;">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
    <AppUpdate ref="appUpdate" :loading="loading" @ensure="ensure"
               :loading-text="loadingText" :description="description"/>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import AppUpdate from "@/comps/AppUpdate";

export default {
  name: 'App',
  components: {AppUpdate},
  data() {
    return {
      locale: zhCN,
      loading: false,
      loadingText: "正在下载中",
      description: "您好更新了",
    };
  },
  beforeCreate() {
    this.$store.commit("layout/resize");
    window.addEventListener("resize", () => {
      this.$store.commit("layout/resize");
    });
  },
  mounted() {
    clearTimeout(window.DetectTimeId);
    if (window.IS_ELECTRON) {
      const self = this;
      window.electron.ipcRenderer
        .removeAllListeners("loading-message")
        .removeAllListeners("update-available")
        .removeAllListeners("update-not-available");
      window.electron.ipcRenderer
          .on("loading-message", (evt, msg) => {
            self.loading = true;
            self.loadingText = msg;
            self.$refs.appUpdate.open();
          })
          .on("update-available", (evt, info) => {
            self.loading = false;
            self.description = info.description;
            self.$refs.appUpdate.open();
          })
          .on("update-not-available", (evt, info) => {
            self.$refs.appUpdate.cancel();
            self.$message.success(`当前已是最新版本${info.version}`);
          });
      window.electron.ipcRenderer.send("check-update");
    }
  },
  methods: {
    ensure() {
      window.electron.ipcRenderer.send("ensure-update");
    }
  }
}
</script>
